/**
 * Generated from ch6_p04.fla
 */
export function ch6_p04(this: Ich6_p04) {
	const rain = this.rain;
	if (!rain[0] && rain.elementFactory) {
		rain[0] = rain.elementFactory(0,undefined);
	}
	if (rain[0]) {
		ch6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain2.call(rain[0] as Ich6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain2);
		rain[0].x = 820.5;
		rain[0].y = 376.75;
		rain[0].width = 1641.00;
		rain[0].height = 753.50;
		rain[0].alpha = 1;
		if (rain[0].onLayout) rain[0].onLayout();
	}
	if (!rain[1] && rain.elementFactory) {
		rain[1] = rain.elementFactory(1,undefined);
	}
	if (rain[1]) {
		ch6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain1.call(rain[1] as Ich6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain1);
		rain[1].x = 813.75;
		rain[1].y = 387.5;
		rain[1].width = 1600.50;
		rain[1].height = 761.00;
		rain[1].alpha = 1;
		if (rain[1].onLayout) rain[1].onLayout();
	}
	const bg = this.bg;
	ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const hollyBody = this.hollyBody;
	ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollybody.call(this.hollyBody);
	hollyBody.x = 830.75;
	hollyBody.y = 768;
	hollyBody.width = 541.50;
	hollyBody.height = 750.00;
	hollyBody.alpha = 1.00;
	if (hollyBody.onLayout) hollyBody.onLayout();
	const hollyArms = this.hollyArms;
	ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollyarms.call(this.hollyArms);
	hollyArms.x = 837;
	hollyArms.y = 768;
	hollyArms.width = 519.00;
	hollyArms.height = 232.00;
	hollyArms.alpha = 1.00;
	if (hollyArms.onLayout) hollyArms.onLayout();
	const frameRight = this.frameRight;
	ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 690;
	linesRight.width = 118.50;
	linesRight.height = 156.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLayer331.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 709.5;
	linesLeft.width = 63.50;
	linesLeft.height = 48.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_bg(this: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p04_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollybody(this: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollybody) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p04_hollybody", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollyarms(this: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollyarms) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p04_hollyarms", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain2(this: Ich6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain1(this: Ich6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRframe(this: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRlines(this: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLframe(this: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLayer331(this: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLayer331) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer331", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
interface Ich6_p04Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p04Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p04Sprite extends Ich6_p04Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p04Text extends Ich6_p04Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p04Polygon extends Array<number> {
}
interface Ich6_p04 {
	readonly rain: Ich6_p04Array<Ich6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain2|Ich6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain1>;
	readonly bg: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_bg;
	readonly hollyBody: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollybody;
	readonly hollyArms: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollyarms;
	readonly frameRight: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRframe;
	readonly linesRight: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRlines;
	readonly frameLeft: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLframe;
	readonly linesLeft: Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLayer331;
}
interface Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_bg extends Ich6_p04Sprite {
}
interface Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollybody extends Ich6_p04Sprite {
}
interface Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_hollyarms extends Ich6_p04Sprite {
}
interface Ich6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain2 extends Ich6_p04Sprite {
}
interface Ich6_p04_hh_ch6_72dpi_p04psdAssetrainoverlayrain1 extends Ich6_p04Sprite {
}
interface Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRframe extends Ich6_p04Sprite {
}
interface Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeRlines extends Ich6_p04Sprite {
}
interface Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLframe extends Ich6_p04Sprite {
}
interface Ich6_p04_hh_ch6_72dpi_p04psdAssetchp6_p04_wcframeLayer331 extends Ich6_p04Sprite {
}
